import cn from 'classnames';
import { useState } from 'react';
import { createPortal } from 'react-dom';

import { Eye } from '@webapp/common/assets/icons';
import { ImageSlider } from '@webapp/common/components/image-slider';
import { CssQuestionType } from '@webapp/common/components/survey-custom';
import { CDN_URL } from '@webapp/common/conf';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';
import { selectInfo } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

import css from './five-sec-test.css';

export const FiveSecTest: FC<SurveyQuestion> = ({ question, readOnly, questionBlockPosition }) => {
    const { filePath, responseActor, id, params } = question;
    const info = useStateSelector(selectInfo);

    const [showSlider, setShowSlider] = useState<boolean>(false);
    const [watched, setWatched] = useState<boolean>(false);

    const onImageClick = () => {
        if (watched) return;

        setWatched(true);
        setShowSlider(true);

        setTimeout(() => {
            setShowSlider(false);
            responseActor.send({ type: 'CHANGE', value: true, questionId: id });
        }, (params?.fiveSecDuration || 5) * 1000);
    };

    const renderImage = () => {
        const image = (
            <div className={cn(css.imageWrap, { [css.imageWrapPreview]: readOnly })}>
                <div className={css.imageBlur}>
                    <img className={css.image} src={CDN_URL + filePath} alt='image' />
                </div>
                {!watched && (
                    <div className={css.imageTooltipWrap}>
                        <Eye className={css.eyeIcon} />
                        <div className={css.blurText}>{info.params?.alert?.fiveSecTestImageText}</div>
                    </div>
                )}
            </div>
        );

        if (readOnly) {
            return image;
        }
        return (
            <>
                <div style={{ cursor: watched ? 'default' : 'pointer' }} onClick={onImageClick}>
                    {image}
                </div>
                {showSlider &&
                    createPortal(
                        <ImageSlider slides={[{ id: 1, img: { url: CDN_URL + filePath } }]} hideCloseIcon={true} />,
                        document.body,
                    )}
            </>
        );
    };

    return (
        <div
            className={cn(css.fiveSecTest, CssQuestionType.QUESTION, CssQuestionType.FIVE_SEC_TEST)}
            style={{ textAlign: questionBlockPosition }}
        >
            {filePath ? renderImage() : 'Нет фото'}
        </div>
    );
};
